
document.addEventListener('DOMContentLoaded' , () =>{
	//qna-lists-page
	if(document.querySelector('.qna-list')){
		const btnQna = document.querySelectorAll(".js-btn-qna");

        btnQna.forEach((el) => {
            let qnaItemArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js-qna-item'));

            el.addEventListener('click' , function(e){
                if(el.parentNode.classList.contains('on')){
                    el.parentNode.classList.remove('on');
                }else{
                    qnaItemArray.forEach(function(el){
                        el.parentNode.classList.remove('on');
                    });
                    el.parentNode.classList.add('on');
                }
            });
		});
	}

    // mylafent - lnb
    if (document.querySelector('.mylafent-area')) {
        const listLi = document.querySelectorAll('.side-menu__item');
        const mylafentArea = document.querySelector('.mylafent');
        const defaultHeight = document.querySelector('.side-menu').scrollHeight;        

        mylafentArea.style.minHeight = defaultHeight + "px";
        
        listLi.forEach((el, idx) => {
            const sideBtn = el.querySelector('.js-btn-sideMenu');
            const hiddenBox = el.querySelector('.side-menu__sub-list');

            if(el.classList.contains('on')){
                el.querySelector('.js-btn-sideMenu').classList.add('active');
                el.querySelector('.side-menu__sub-list').style.display = "block";
            }
            
            sideBtn.addEventListener('click', () => {
                
                if (hiddenBox.style.display === 'block') {
                    hiddenBox.style.display = 'none';
                    sideBtn.classList.remove('active');
                    sideBtn.parentNode.classList.remove('on');

                    mylafentArea.style.minHeight = "auto";
                    
                } else {                    
                    listLi.forEach((item) => {
                        const otherHiddenBox = item.querySelector('.side-menu__sub-list');
                        const otherBtn = item.querySelector('.js-btn-sideMenu');
                        
                        if (otherHiddenBox && otherHiddenBox !== hiddenBox) {
                            otherHiddenBox.style.display = 'none';
                            otherBtn.classList.remove('active');
                        }
                    });                

                    hiddenBox.style.display = 'block';                    
                    sideBtn.classList.add('active');

                    const parentHeight = sideBtn.closest('.side-menu').scrollHeight;
                    mylafentArea.style.minHeight = parentHeight + "px";
                }
            });
        });
    }
});
